import React, { Component } from "react";
import parseHTML from 'html-react-parser';
import { connect } from 'react-redux';
import { Layout, Block, Row, Col } from '../../components';
import * as userActions from '../../actions/user'
import { StoreState, ApplicationState } from './../../types';
import {H2, PageStyle, H1, H3} from "../../styles/global";

type RulesProps = {
	application: ApplicationState;

}

class Rules extends Component<RulesProps> {
	state = {
		text: ''
	}

	componentDidMount() {
		userActions.getRules(this.props.application.competition.competitionFeed)
			.then((result: any) => {
				const body = result && result.translations && result.translations[0] && result.translations[0].body;
				this.setState({ text: body || '' })
			});
	}

	render() {
		return (
			<Layout><Row>
				<Col span={24}>
					<Block style={{color: "#FFF !important"}}>
					{ parseHTML(this.state.text) }
					</Block>
				</Col>
			</Row></Layout>
		);
	}
}

export function mapStateToProps({ application }: StoreState.All) {
	return {
		application
	}
}

export default connect(mapStateToProps, {})(Rules);
